import { httpClient, HttpMethod } from './http-client';
import {
  CreateFreightOrderType,
  ArchiveFreightOrderType,
  ReturnFreightOrderType,
  QuoteFreightOrderType,
  FreightPackageTypeResponse,
  QuoteFreightOrderTypeResponse,
  FreightOrderByShipment,
} from '../@types/shipment.type';

export const getFreightPackageTypes = (): Promise<FreightPackageTypeResponse[]> => {
  return httpClient<FreightPackageTypeResponse[]>('/freightPackageTypes', HttpMethod.Get);
};

export const createFreightOrder = (freightOrder: CreateFreightOrderType): Promise<void> => {
  return httpClient<void>('/freightOrder', HttpMethod.Post, freightOrder);
};

export const archiveFreightOrder = (freightOrder: ArchiveFreightOrderType): Promise<void> => {
  return httpClient<void>('/archiveOrder', HttpMethod.Post, freightOrder);
};

export const returnFreightOrder = (freightOrder: ReturnFreightOrderType): Promise<void> => {
  return httpClient<void>('/returnOrder', HttpMethod.Post, freightOrder);
};

export const quoteFreightOrder = (freightOrder: QuoteFreightOrderType): Promise<QuoteFreightOrderTypeResponse[]> => {
  return httpClient<QuoteFreightOrderTypeResponse[]>('/deliveryservices', HttpMethod.Post, freightOrder);
};

export const freightOrderByShipment = (shipmentId: number): Promise<FreightOrderByShipment[]> => {
  return httpClient<FreightOrderByShipment[]>(`/freightOrder/shipment/${shipmentId}`, HttpMethod.Get);
};
